/**
 * @file 课程
 * @author 丁聪
 */

import React, { Component } from 'react'
import {
  Banner,
  Trait,
  Interest,
  Many,
  Study,
  Set,
  Make,
} from './components/index'
import { Footer } from '../../components/basic/index'
import './index.scss'

class Course extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      flag: true
    }
  }

  handleScroll = (event) => {        //滚动条高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop, //滚动条滚动高度
      { flag } = this.state;  //滚动条滚动高度
    if (scrollTop > 2200 && scrollTop < 2800) {
      if (flag) {
        this.setState({ flag: false, show: true })
      }
    } else {
      this.setState({ flag: true, show: false })
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    let { show } = this.state;
    return (
      <div className='course-wrap'>
        <Banner />
        <Trait />
        <Many />
        <Interest />
        <div className='circle-all'>
          <div className="inner-title">利用AI+大数据赋能教学，形成学习场景闭环</div>
          <div className='circle-wrap'>
            <div className={show ? 'circle circle-1 circle-1-after' : 'circle circle-1'}></div>
            <div className={show ? 'circle circle-2 circle-2-after' : 'circle circle-2'}></div>
            <div className={show ? 'circle circle-3 circle-3-after' : 'circle circle-3'}></div>
            <div className={show ? 'circle circle-4 circle-4-after' : 'circle circle-4'}></div>
            <div className={show ? 'circle circle-5 circle-5-after' : 'circle circle-5'}></div>
          </div>
        </div>
        <Study />
        <Set />
        <Make />
        <Footer />
      </div>
    )
  }
}

export default Course
